/** Cache using session storage **/

export default class Cache {
  constructor(storage, type) {
    this.storage = storage;
    this.type = type;
    this.ttl = {};
  }

  delete(key) {
    this.storage.removeItem(key);
  }

  get(key) {
    const value = this.storage.getItem(key);
    return this.type === 'json'
      ? JSON.parse(value)
      : value;
  }

  set(key, obj, ttl) {
    const value = this.type === 'json'
      ? JSON.stringify(obj)
      : obj;
    this.storage.setItem(key, value);
    if (ttl) {
      clearTimeout(this.ttl[key]);
      this.ttl[key] = setTimeout(() => this.delete(key), ttl);
    }
    return this.get(key);
  }

  reset() {
    this.storage.clear();
  }
}

export class MemStorage {
  constructor() {
    window.__memstorage__ = window.__memstorage__ || {};
  }

  clear() {
    window.__memstorage__ = {};
  }

  getItem(key) {
    return window.__memstorage__[key];
  }

  removeItem(key) {
    delete (window.__memstorage__[key]);
  }

  setItem(key, obj) {
    window.__memstorage__[key] = obj;
  }
}

export const keygenDefault = (name, args = []) => btoa(JSON.stringify([name, ...args]));
export const memoize = (cache) => ({ keygen, method, name, ttl }) => (args = []) => {
  const key = (keygen || keygenDefault)(name, args);

  const exists = cache.get(key);
  if (exists) return exists;

  const res = method(...args);
  cache.set(key, res, ttl);
  return res;
};
